import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import FastClick from 'fastclick'
import Vant from 'vant';
import 'vant/lib/index.css'; // 引入 Vant 的样式文件
import VueTouch from 'vue-touch';
Vue.use(VueTouch, {
  name: 'v-touch'
});
VueTouch.config.swipe = {
  threshold: 10 //手指左右滑动触发事件距离
}
Vue.use(Vant);
FastClick.attach(document.body)

Vue.config.productionTip = false
axios.defaults.baseURL = 'https://api.zhibo.yunji.world/web/download'
axios.defaults.timeout = 5000 // 修正拼写错误

// 将 axios 添加到 Vue 实例的原型中
Vue.prototype.$axios = axios

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')